(() => {
  const initProduct = root => {
    if (root.dataset.asInitialized) return;
    const form = root.querySelector('[data-as-form]');
    const select = root.querySelector('[data-as-variant-select]');
    const submit = root.querySelector('[data-as-submit]');
    if (!form || !select || !submit) return;
    const variants = JSON.parse(root.querySelector('[data-as-variants]').textContent);
    const quantity = root.querySelector('[data-as-quantity]');
    const toggle = root.querySelector('[data-as-plan-toggle]');
    const planSelect = root.querySelector('[data-as-plan-select]');
    const status = root.querySelector('[data-as-status]');
    const slides = Array.from(root.querySelectorAll('[data-as-slide]'));
    const requestedVariant = new URL(window.location.href).searchParams.get('variant');
    let variant = variants.find(item => String(item.id) === (requestedVariant || select.value)) || variants.find(item => String(item.id) === select.value) || variants[0];
    let pending = false;
    root.dataset.asInitialized = 'true';
    const cartLanguage = root.querySelector('[data-as-cart-language]');
    if (cartLanguage) {
      const labels = JSON.parse(cartLanguage.textContent);
      Object.assign(window.cartStrings ||= {}, { error: labels.error, quantityError: labels.quantityError });
      Object.assign(window.quickOrderListStrings ||= {}, { min_error: labels.min_error, max_error: labels.max_error, step_error: labels.step_error });
    }
    root.classList.add('is-ready');
    const formatter = new Intl.NumberFormat(root.dataset.locale || 'en', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    const money = (price, formatted, count = 1) => count === 1 && formatted ? formatted : formatter.format(price * count / 100);
    const showMedia = id => {
      const chosen = slides.find(slide => slide.dataset.mediaId === String(id));
      if (!chosen) return;
      slides.forEach(slide => {
        slide.hidden = slide !== chosen;
        if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
        if (slide.hidden) slide.querySelectorAll('iframe').forEach(frame => {
          if (frame.src) frame.src = frame.src;
        });
      });
      root.querySelectorAll('[data-as-thumb]').forEach(thumb => {
        const active = thumb.dataset.asThumb === String(id);
        thumb.setAttribute('aria-pressed', String(active));
        if (active) {
          const row = thumb.parentElement;
          row.scrollTo?.({ left: thumb.offsetLeft - row.offsetLeft - (row.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth' });
        }
      });
    };
    const advanceMedia = delta => {
      const index = slides.findIndex(slide => !slide.hidden);
      const next = slides[(index + delta + slides.length) % slides.length];
      if (next) showMedia(next.dataset.mediaId);
    };
    const activePlan = () => toggle?.checked && planSelect && !planSelect.disabled ? variant.plans.find(plan => String(plan.id) === planSelect.value) : null;
    const updateDelivery = plan => {
      const renewal = root.querySelector('[data-as-renewal]');
      const isRecurring = Boolean(plan?.recurring);
      if (renewal) {
        renewal.hidden = !isRecurring;
        if (isRecurring) {
          const monthly = /(?:^monthly(?:\b|$)|\bevery month\b)/i.test(plan.name || '') && !/prepaid/i.test(plan.name || '') && Number(plan.price) === Number(plan.deliveryPrice);
          renewal.textContent = monthly ? renewal.dataset.monthly : renewal.dataset.general;
        }
      }
      const benefits = root.querySelector('[data-as-subscription-benefits]');
      if (!benefits) return;
      const offeredPlan = isRecurring ? plan : variant.plans.find(item => item.recurring);
      benefits.hidden = !offeredPlan;
      const discount = root.querySelector('[data-as-discount-benefit]');
      const copy = root.querySelector('[data-as-discount-copy]');
      if (!discount || !copy) return;
      const percentage = offeredPlan && variant.price > 0 ? Math.round((variant.price - Number(offeredPlan.deliveryPrice)) / variant.price * 100) : 0;
      discount.hidden = percentage <= 0;
      if (percentage > 0) {
        const adjustments = offeredPlan.adjustments || [];
        const permanent = adjustments.length === 1 && adjustments[0].order_count == null && adjustments[0].value_type === 'percentage' && Math.round(Number(adjustments[0].value)) === percentage;
        copy.textContent = percentage + '% ' + (permanent ? copy.dataset.permanent : copy.dataset.standard);
      }
    };
    const updatePrices = () => {
      const plan = activePlan();
      const pricing = plan || variant;
      updateDelivery(plan);
      const oncePrice = root.querySelector('[data-as-once-price]');
      if (oncePrice) oncePrice.textContent = money(variant.price, variant.money);
      const once = root.querySelector('[data-as-once]');
      if (once) once.hidden = root.dataset.requiresPlan === 'true' || variant.requiresPlan;
      const savingPlan = plan || variant.plans[0];
      const savings = root.querySelector('[data-as-savings]');
      if (savings) {
        const percentage = savingPlan && variant.price > 0 ? Math.round((variant.price - savingPlan.price) / variant.price * 100) : 0;
        savings.hidden = percentage <= 0;
        savings.textContent = percentage > 0 ? percentage + '%' : '';
      }
      const count = Math.max(variant.min, Number(quantity?.value) || variant.min);
      root.querySelector('[data-as-total]').textContent = money(pricing.price, pricing.money, count);
      const compare = root.querySelector('[data-as-total-compare]');
      compare.hidden = !(pricing.compare > pricing.price);
      compare.textContent = money(pricing.compare || 0, pricing.compareMoney, count);
      const stickyPrice = root.querySelector('[data-as-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(pricing.price, pricing.money, count);
      root.querySelectorAll('[data-as-offer]').forEach(offer => {
        const item = variants.find(value => String(value.id) === offer.dataset.asOffer);
        const itemPrice = plan ? item.plans.find(value => String(value.id) === String(plan.id)) || item : item;
        offer.classList.toggle('is-selected', item.id === variant.id);
        offer.querySelector('[data-as-choice-price]').textContent = money(itemPrice.price, itemPrice.money);
        const daily = offer.querySelector('[data-as-daily]');
        if (daily && Number(daily.dataset.days) > 0) daily.textContent = money(Math.round(itemPrice.price / Number(daily.dataset.days)));
        const itemCompare = offer.querySelector('[data-as-choice-compare]');
        itemCompare.hidden = !(itemPrice.compare > itemPrice.price);
        itemCompare.textContent = money(itemPrice.compare || 0, itemPrice.compareMoney);
      });
      root.querySelectorAll('input[name="as_variant_choice"]').forEach(input => { input.checked = input.value === String(variant.id); });
      const needsPlan = root.dataset.requiresPlan === 'true' || variant.requiresPlan;
      submit.disabled = pending || !variant.available || (needsPlan && !plan);
      if (!pending) submit.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldOut;
      const terms = root.querySelector('[data-as-plan-terms]');
      if (terms) terms.hidden = !plan;
    };
    const updateVariant = (id, changeURL = true) => {
      variant = variants.find(item => String(item.id) === String(id)) || variants[0];
      select.value = String(variant.id);
      const previousPlan = planSelect?.value;
      if (toggle && planSelect) {
        const required = root.dataset.requiresPlan === 'true' || variant.requiresPlan;
        toggle.disabled = required;
        if (required) toggle.checked = true;
        if (!variant.plans.length) toggle.checked = false;
        root.querySelector('[data-as-plan-box]').hidden = !variant.plans.length;
        planSelect.replaceChildren(...variant.plans.map(plan => {
          const option = document.createElement('option');
          option.value = String(plan.id);
          option.textContent = plan.name;
          return option;
        }));
        if (variant.plans.some(plan => String(plan.id) === previousPlan)) planSelect.value = previousPlan;
        planSelect.disabled = !toggle.checked || !variant.plans.length;
      }
      if (quantity) {
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max;
        else quantity.removeAttribute('max');
        let count = Math.max(variant.min, Number(quantity.value) || variant.min);
        count = variant.min + Math.floor((count - variant.min) / variant.step) * variant.step;
        if (variant.max) count = Math.min(count, variant.max);
        quantity.value = count;
      }
      showMedia(variant.mediaId);
      status.textContent = '';
      updatePrices();
      if (changeURL && !window.Shopify?.designMode) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };
    form.addEventListener('change', event => {
      if (event.target === select || event.target.name === 'as_variant_choice') updateVariant(event.target.value);
      else if (event.target === toggle) {
        planSelect.disabled = !toggle.checked;
        updatePrices();
      } else if (event.target === planSelect || event.target === quantity) updatePrices();
    });
    root.querySelector('[data-as-once]')?.addEventListener('click', () => {
      if (!toggle || toggle.disabled || !planSelect) return;
      toggle.checked = false;
      planSelect.disabled = true;
      updatePrices();
    });
    quantity?.addEventListener('input', updatePrices);
    root.querySelectorAll('[data-as-thumb]').forEach(thumb => thumb.addEventListener('click', () => showMedia(thumb.dataset.asThumb)));
    root.querySelector('[data-as-prev]')?.addEventListener('click', () => advanceMedia(-1));
    root.querySelector('[data-as-next]')?.addEventListener('click', () => advanceMedia(1));
    const dialog = root.querySelector('[data-as-lightbox]');
    root.querySelectorAll('[data-as-zoom]').forEach(button => button.addEventListener('click', () => {
      const source = button.querySelector('img');
      const image = dialog?.querySelector('img');
      if (!source || !image || !dialog.showModal) return;
      image.removeAttribute('srcset');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      dialog.showModal();
    }));
    root.querySelector('[data-as-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const sticky = root.querySelector('[data-as-sticky]');
    const updateSticky = () => {
      if (!sticky) return;
      sticky.hidden = submit.getBoundingClientRect().bottom > 0;
    };
    if (sticky) {
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      updateSticky();
      root.querySelector('[data-as-return]').addEventListener('click', () => {
        root.querySelector('.as-product-info').scrollIntoView({ behavior: 'smooth', block: 'start' });
        submit.focus({ preventScroll: true });
      });
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending || submit.disabled || !form.reportValidity()) return;
      pending = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      status.textContent = '';
      const item = { id: variant.id, quantity: Number(quantity?.value) || variant.min };
      const plan = activePlan();
      if (plan) item.selling_plan = plan.id;
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const payload = { items: [item] };
      if (drawer?.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(section => section.section || section.id);
        payload.sections_url = window.location.pathname;
        drawer.setActiveElement?.(submit);
      }
      let added = false;
      try {
        const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || root.dataset.error);
        added = true;
        status.textContent = root.dataset.added;
        if (drawer?.renderContents && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...data, id: data.items?.[0]?.id || data.id });
        } else window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        if (added) window.location.assign(root.dataset.cartUrl);
        else status.textContent = error.message || root.dataset.error;
      } finally {
        pending = false;
        submit.removeAttribute('aria-busy');
        updatePrices();
      }
    });
    updateVariant(variant.id, false);
  };
  const init = scope => {
    if (scope.matches?.('[data-as-product]')) initProduct(scope);
    scope.querySelectorAll('[data-as-product]').forEach(initProduct);
    scope.querySelectorAll('[data-as-carousel]').forEach(carousel => {
      if (carousel.dataset.asInitialized) return;
      carousel.dataset.asInitialized = 'true';
      const move = direction => {
        const card = carousel.querySelector('.as-story-card');
        const gap = parseFloat(getComputedStyle(carousel).gap) || 0;
        carousel.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || carousel.clientWidth) + gap), behavior: 'smooth' });
      };
      const container = carousel.closest('.as-content');
      container.querySelector('[data-as-carousel-prev]')?.addEventListener('click', () => move(-1));
      container.querySelector('[data-as-carousel-next]')?.addEventListener('click', () => move(1));
      carousel.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-as-scroll-product]');
    if (!link) return;
    const productInfo = document.querySelector('.as-product-info');
    if (productInfo) { event.preventDefault(); productInfo.scrollIntoView({ behavior: 'smooth' }); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
